// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_IMAGE_PRESET_LIST = 'imagePreset/SET_IMAGE_PRESET_LIST';
export const ADD_IMAGE_PRESET_ITEM = 'imagePreset/ADD_IMAGE_PRESET_ITEM';
export const SET_IMAGE_PRESET_ITEM = 'imagePreset/SET_IMAGE_PRESET_ITEM';
export const UNSET_IMAGE_PRESET_ITEM = 'imagePreset/UNSET_IMAGE_PRESET_ITEM';
export const REMOVE_IMAGE_PRESET_ITEM = 'imagePreset/REMOVE_IMAGE_PRESET_ITEM';
export const UPDATE_IMAGE_PRESET_ITEM = 'imagePreset/UPDATE_IMAGE_PRESET_ITEM';
export const SET_IMAGE_PRESET_ITEM_IS_DELETING = 'imagePreset/SET_IMAGE_PRESET_ITEM_IS_DELETING';
